import { createStore as reduxCreateStore, applyMiddleware } from "redux"
import thunk from 'redux-thunk'
import reduxLogger from 'redux-logger'
import mainReducer from '../state/reducers/index'

const createStore = () => reduxCreateStore(mainReducer, applyMiddleware(thunk, reduxLogger))
export default createStore